import React from 'react';
import { CtaBlock } from './CtaBlock';
export function HeroSection() {
  return <section className="w-full bg-editorial-bg pt-16 pb-section-mobile md:pb-section-desktop px-6 md:px-8 bg-gradient-to-b from-editorial-bg to-editorial-bgAlt" data-id="element-73">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-74">
        <p className="text-[10px] md:text-xs font-sans font-medium tracking-[0.25em] text-editorial-textMuted uppercase mb-8" data-id="element-75">
          DOCUMENTED INVESTIGATION • SEPTEMBER 10, 2025 • 16 CHAPTERS • INSTANT
          ACCESS
        </p>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-editorial-text leading-tight mb-6" data-id="element-76">
          They thought silencing one voice would silence the movement.
          <br className="hidden md:block" data-id="element-77" />
          They were wrong.
        </h1>

        <h2 className="text-xl md:text-2xl font-sans text-editorial-textMuted mb-6 leading-relaxed" data-id="element-78">
          You already knew something was wrong.
          <br className="hidden md:block" data-id="element-79" />
          This is the full investigation that proves it.
        </h2>

        <p className="text-sm md:text-base font-sans text-editorial-text mb-8 max-w-2xl leading-relaxed" data-id="element-80">
          A 16-chapter investigative ebook documenting how intolerance became
          violence — and why September 10, 2025 was inevitable.
        </p>

        <div className="mb-8 text-sm md:text-base text-editorial-textMuted font-sans flex items-center justify-center gap-2" data-id="element-81">
          <span className="text-editorial-accent tracking-widest" data-id="element-82">★★★★★</span>
          <span data-id="element-83">4.9/5 — Based on Early Reader Reviews</span>
        </div>

        <div className="w-full max-w-md mx-auto mb-16" data-id="element-84">
          <CtaBlock buttonText="Get Instant Access — $13.99" data-id="element-85" />
        </div>

        <div className="w-full max-w-md mx-auto" data-id="element-86">
          <img src="https://cdn.magicpatterns.com/uploads/pXxcLZXbwN4rNSkNfZAUPv/imagen_publicidad_y_landing.png" alt="CK The Voice They Couldn't Silence: HOW INTOLERANCE BECAME VIOLENCE - Book Cover on iPad" className="w-full h-auto object-contain max-h-[60vh] drop-shadow-2xl" loading="eager" data-id="element-87" />
        </div>
      </div>
    </section>;
}